var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"button-remove--is-sliding"}},[(_vm.show)?_c('div',{staticClass:"button-remove",domProps:{"textContent":_vm._s(_vm.text)},on:{"click":_vm.remove}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }